var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTypeSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.686,
    height: 26.686,
    viewBox: "0 0 26.686 26.686",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.66943 .852)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.8028 4.6037 2.1637 2.079 2.0445-2.1134",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.64 5.6531 8.1594-.0543",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.66943 8.1549)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.8028 4.6037 2.1637 2.079 2.0445-2.1134",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.64 5.6531 8.1594-.0543",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.66943 15.397)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.8028 4.6037 2.1637 2.079 2.0445-2.1134",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.64 5.6531 8.1594-.0543",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeSection);
export default __webpack_public_path__ + "static/media/icon_type_section.a152b02d2081c86cd2e4c856db1056e5.svg";
export { ForwardRef as ReactComponent };